import validate from "/harness/node_modules/.pnpm/nuxt@3.20.1_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc@3.5.24_db0@0.3._3d7fa9b0102dbe17d9dcb9500aa26559/node_modules/nuxt/dist/pages/runtime/validate.js";
import normalize_45slashes_45global from "/harness/packages/base/app/middleware/normalizeSlashes.global.ts";
import redirect_45global from "/harness/apps/sf/app/middleware/redirect.global.ts";
import manifest_45route_45rule from "/harness/node_modules/.pnpm/nuxt@3.20.1_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc@3.5.24_db0@0.3._3d7fa9b0102dbe17d9dcb9500aa26559/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  normalize_45slashes_45global,
  redirect_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}